(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-experiences"] && !Shopify.designMode) return;
  try {
    

(()=>{
const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';
const guide=root.querySelector('[data-pv-guide]');if(guide){let current=0;const form=guide.querySelector('form'),steps=[...form.querySelectorAll('[data-step]')],prev=guide.querySelector('[data-prev]'),next=guide.querySelector('[data-next]'),finish=guide.querySelector('[data-finish]'),result=guide.querySelector('.pv-guide-result');const show=()=>{steps.forEach((s,i)=>{s.hidden=i!==current;s.querySelectorAll('input').forEach(input=>input.required=i===current);});prev.hidden=current===0;next.hidden=current===steps.length-1;finish.hidden=current!==steps.length-1;guide.querySelector('.pv-guide-progress').textContent=(current+1)+' / '+steps.length;};show();next.onclick=()=>{if(!form.reportValidity())return;current++;show();steps[current].querySelector('input').focus();};prev.onclick=()=>{current--;show();steps[current].querySelector('input').focus();};form.onsubmit=e=>{e.preventDefault();if(!form.reportValidity())return;const selected=[...form.querySelectorAll('input:checked')];if(selected.length!==steps.length)return;const route=guide.querySelector('[data-offer="'+selected[0].value+'"]');const summary=selected.map(input=>input.closest('fieldset').querySelector('legend').textContent+' '+input.nextElementSibling.textContent).join('\n');guide.querySelector('[data-result-title]').textContent=route.textContent;guide.querySelector('[data-result-summary]').textContent=summary;const url=new URL(route.href,location.origin);url.searchParams.set('pv_context',summary);guide.querySelector('[data-result-link]').href=url.href;form.hidden=true;result.hidden=false;result.focus();};guide.querySelector('[data-restart]').onclick=()=>{result.hidden=true;form.hidden=false;current=0;show();steps[0].querySelector('input').focus();};}
const flip=root.querySelector('[data-flip]');if(flip){let page=0;const imgs=[...flip.querySelectorAll('img')],prev=flip.querySelector('[data-flip-prev]'),next=flip.querySelector('[data-flip-next]');const show=()=>{imgs.forEach((img,i)=>img.hidden=i!==page);prev.disabled=page===0;next.disabled=page===imgs.length-1;flip.querySelector('output').textContent=(page+1)+' / '+imgs.length;};prev.onclick=()=>{page--;show();};next.onclick=()=>{page++;show();};show();}
const time=root.querySelector('[data-time]');if(time){const inputs=[...time.querySelectorAll('input')];const calc=()=>{if(inputs.some(x=>!x.validity.valid||x.value==='')){time.querySelector('output').textContent='—';return;}const count=Number(inputs[0].value),before=Number(inputs[1].value),after=Number(inputs[2].value);time.querySelector('output').textContent=((count*(before-after)*4)/60).toLocaleString('fr-CA',{maximumFractionDigits:1});};inputs.forEach(x=>x.addEventListener('input',calc));calc();}
const dashboard=root.querySelector('[data-dashboard]');if(dashboard){const rows=[{total:12,done:8},{total:18,done:15},{total:16,done:12}];const select=dashboard.querySelector('select');const update=()=>{const row=rows[Number(select.value)],rate=Math.round(row.done/row.total*100);dashboard.querySelector('[data-total]').textContent=row.total;dashboard.querySelector('[data-done]').textContent=row.done;dashboard.querySelector('[data-rate]').textContent=rate+' %';dashboard.querySelector('[data-bar]').style.width=rate+'%';};select.onchange=update;update();}
const controls=root.querySelector('[data-custom-controls]');if(controls){const cover=root.querySelector('[data-cover]'),title=controls.querySelector('[data-cover-title]'),format=controls.querySelector('[data-cover-format]'),color=controls.querySelector('[data-cover-color]'),pages=controls.querySelector('[data-cover-pages]'),link=root.querySelector('[data-custom-link]'),base=link.href,defaultTitle=title.value;const update=()=>{root.querySelector('[data-cover-heading]').textContent=title.value.trim()||defaultTitle;root.querySelector('[data-cover-caption]').textContent=pages.value;cover.classList.toggle('pv-cover--landscape',format.value==='landscape');cover.style.background={ivory:'#f9f6e9',sage:'#dde4cf',sand:'#e8dcc8'}[color.value];const summary=[...controls.querySelectorAll('label')].map(label=>{const input=label.querySelector('input,select');return label.childNodes[0].textContent.trim()+': '+(input.tagName==='SELECT'?input.selectedOptions[0].textContent:input.value);}).join('\n');const url=new URL(base,location.origin);url.searchParams.set('pv_context',summary);link.href=url.href;};controls.addEventListener('input',update);controls.addEventListener('change',update);update();}
};const boot=()=>document.querySelectorAll('[data-pv-lab]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-files-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.pv-files-appointment');if(!link)return;const input=document.getElementById(link.hash.slice(1));if(!input)return;event.preventDefault();if(!input.value)input.value=link.textContent.trim();input.focus();input.scrollIntoView({block:'center',behavior:'auto'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-header"] && !Shopify.designMode) return;
  try {
    
(()=>{
const close=(menu,focus=false)=>{menu.removeAttribute('open');if(focus)menu.querySelector('summary').focus();};
document.addEventListener('click',e=>{document.querySelectorAll('.pv-mega[open],.pv-mobile-menu[open]').forEach(menu=>{if(!menu.contains(e.target)||e.target.closest('a'))close(menu);});});
document.addEventListener('keydown',e=>{const mobile=document.querySelector('.pv-menu-v2 .pv-mobile-menu[open]');const open=e.target.closest('.pv-mega[open]')||mobile;if(e.key==='Escape'&&open){e.preventDefault();close(open,true);}if(e.key==='Tab'&&mobile){const items=[...mobile.querySelectorAll('summary,a[href],button')].filter(x=>x.getClientRects().length);const first=items[0],last=items.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
document.addEventListener('focusin',e=>{document.querySelectorAll('.pv-mega[open]').forEach(menu=>{if(!menu.contains(e.target))close(menu);});});
window.addEventListener('resize',()=>{if(window.innerWidth>=1000)document.querySelectorAll('.pv-mobile-menu[open]').forEach(menu=>close(menu));else document.querySelectorAll('.pv-mega[open]').forEach(menu=>close(menu));});
const prefill=()=>{const context=new URLSearchParams(location.search).get('pv_context');if(!context)return;const field=document.querySelector('main textarea[name="contact[body]"]');if(field&&!field.value){field.value=context.slice(0,1800);field.dispatchEvent(new Event('input',{bubbles:true}));}};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prefill,{once:true});else prefill();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-intake"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.pv-appointment');if(!link)return;const input=document.getElementById(link.hash.slice(1));if(!input)return;event.preventDefault();if(input instanceof HTMLInputElement&&!input.value)input.value=link.textContent.trim();input.focus();input.scrollIntoView({block:'center',behavior:'auto'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-mandat-form"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('[data-mandat-choice]').forEach(choice=>{if(choice.dataset.ready)return;choice.dataset.ready='true';const value=new URLSearchParams(location.search).get('mandat');if(choice.value==='indecis'&&['ponctuel','regulier'].includes(value))choice.value=value;});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-parallax-control"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-parallax-preview')) {
  customElements.define('pv-parallax-preview', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('#pv-parallax-page');
      if (!this.root) return;
      this.button = this.querySelector('button');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.paused = this.reduced.matches;
      this.layers = [];
      this.frame = null;
      this.onScroll = () => this.queue();
      this.onPreference = () => { this.paused = this.reduced.matches; this.updateState(); };
      this.onRefresh = () => { this.collect(); this.updateState(); };
      this.onToggle = () => { this.paused = !this.paused; this.updateState(); };
      this.button.addEventListener('click', this.onToggle);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.reduced.addEventListener('change', this.onPreference);
      this.mobile.addEventListener('change', this.onScroll);
      document.addEventListener('shopify:section:load', this.onRefresh);
      document.addEventListener('shopify:section:reorder', this.onRefresh);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onRefresh, { once: true });
      else this.onRefresh();
    }

    collect() {
      this.scene = this.root.querySelector('.pv-parallax-scene');
      this.hero = this.root.querySelector('.pv-hero');
      this.layers = [];
      const groups = [
        ['.pv-rhythm-card > img', '.pv-rhythm-card', .4, 80],
        ['.pv-services-leaf', '.pv-services', -.23, 95],
        ['.pv-service-grid', '.pv-services', -.12, 30],
        ['.pv-gallery-image img', '.pv-gallery-image', -.12, 16],
        ['.pv-about-leaf', '.pv-about', .3, 85],
        ['.pv-about-signature', '.pv-about', -.12, 35]
      ];
      groups.forEach(([selector, anchorSelector, speed, limit]) => {
        this.root.querySelectorAll(selector).forEach(element => {
          element.dataset.pvLayer = '';
          this.layers.push({ element, anchor: element.closest(anchorSelector), speed, limit });
        });
      });
    }

    updateState() {
      this.active = !this.paused;
      this.root.dataset.pvMotion = this.active ? 'active' : 'paused';
      this.button.hidden = false;
      this.button.disabled = false;
      this.button.setAttribute('aria-pressed', String(this.active));
      this.button.textContent = this.active ? this.dataset.pauseLabel : this.dataset.playLabel;
      if (!this.active) {
        this.layers.forEach(({ element }) => element.style.removeProperty('--pv-shift'));
        this.root.style.removeProperty('--pv-copy-shift');
      }
      this.queue();
    }

    queue() {
      if (!this.active || this.frame !== null) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.draw(); });
    }

    draw() {
      if (!this.active) return;
      const height = window.innerHeight;
      const factor = this.mobile.matches ? .5 : 1;
      let copyShift = 0;
      if (this.scene && this.hero) {
        const rect = this.scene.getBoundingClientRect();
        const travel = Math.max(0, rect.height - this.hero.offsetHeight);
        copyShift = -Math.max(0, Math.min(travel, -rect.top)) * .95;
      }
      const positions = this.layers.map(layer => {
        const rect = layer.anchor.getBoundingClientRect();
        const shift = (height / 2 - rect.top - rect.height / 2) * layer.speed;
        return Math.max(-layer.limit, Math.min(layer.limit, shift)) * factor;
      });
      this.layers.forEach(({ element }, index) => element.style.setProperty('--pv-shift', `${positions[index].toFixed(2)}px`));
      this.root.style.setProperty('--pv-copy-shift', `${copyShift.toFixed(2)}px`);
    }

    disconnectedCallback() {
      if (!this.root) return;
      cancelAnimationFrame(this.frame);
      this.button.removeEventListener('click', this.onToggle);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.reduced.removeEventListener('change', this.onPreference);
      this.mobile.removeEventListener('change', this.onScroll);
      document.removeEventListener('DOMContentLoaded', this.onRefresh);
      document.removeEventListener('shopify:section:load', this.onRefresh);
      document.removeEventListener('shopify:section:reorder', this.onRefresh);
      this.root.dataset.pvMotion = 'paused';
      this.layers.forEach(({ element }) => element.style.removeProperty('--pv-shift'));
      this.root.style.removeProperty('--pv-copy-shift');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-tools-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.pv-tools-appointment');if(!link)return;const input=document.getElementById(link.hash.slice(1));if(!input)return;event.preventDefault();if(!input.value)input.value=link.textContent.trim();input.focus();input.scrollIntoView({block:'center',behavior:'auto'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-web-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.pv-web-appointment');if(!link)return;const input=document.getElementById(link.hash.slice(1));if(!input)return;event.preventDefault();if(!input.value)input.value=link.textContent.trim();input.focus();input.scrollIntoView({block:'center',behavior:'auto'});});

  } catch(e) { console.error(e); }
})();
})();
